<template>
  <main
    data-component="checkout-failure-page"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
    v-background-color="$store.getters['ui/getBackgroundColor']"
  >
    <MainHeader :hideTableNumber="true"/>
    <PaymentFailure />
    <btn
      text="Try again"
      data-position="center"
      size="md"
      :fontStyle="{...this.$store.getters['ui/getBodyCopyFontDetail']('normal'), textSize:'18px'}"
      :backgroundColor="$store.getters['ui/getSecondaryColor']"
      @click.native="renderBasketPage"
    >
      Try again
    </btn>
  </main>
</template>

<script>
  import PaymentFailure from '@/components/checkout/PaymentFailure';
  import Btn from '@/components/ui/Btn';
  import MainHeader from '@/components/ui/MainHeader';

  export default {
    name: 'checkout-success-page',
    components: {
      PaymentFailure,
      MainHeader,
      Btn
    },
    methods: {
      renderBasketPage () {
        this.$router.push({ name: 'basket' })
      }
    }
  };
</script>


<style lang="scss" scoped>
  @import '@/assets/scss/variables.scss';
  @import '@/assets/scss/helpers.scss';

  [data-component="checkout-failure-page"] {
    background-color:#fff;
    height:100vh;
    [data-position="center"] {
      width: 300px;
      margin: 0 auto;
    }
  }
</style>
